// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1pe0j","list":"BalanceDue_list__10nBw","listRow":"BalanceDue_listRow__1NlvY","total":"BalanceDue_total__3AKk_"};